import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DataManager, Query, ODataV4Adaptor, Predicate } from '@syncfusion/ej2-data';
import { SaveEventArgs, EditSettingsModel, Logger, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { environment } from 'src/environments/environment';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-sharedwith',
  templateUrl: './sharedwith.component.html',
  styleUrls: ['./sharedwith.component.css']
})
export class SharedwithComponent {
  @Input() relatedTypeId!: number;
  @Input() recordId!: number;

  isMobileView:boolean = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  enableAdaptiveUI:boolean= /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  data!: DataManager;
  query!: Query;
  userData!: DataManager;
  userQuery: Query = new Query().select(['FirstName', 'Id']).take(10);
  baseUrl: string = environment.baseUrl.replace('/api/', '/odata/');
  editSettings!: EditSettingsModel;
  toolbar!: string[];
  columns!: object[];
  public pageOptions: PageSettingsModel =  { pageSize: 25, pageSizes: [25, 50, 100], pageCount: 5 };
  public submitClicked: boolean = false;
  public formData!: UntypedFormGroup;
  currentUser: any
  sharedwidthData!: DataManager;

  constructor(private authenticationService: AuthenticationService, private formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {
    const currentUser = this.authenticationService.currentUserValue;
    this.editSettings = { allowAdding: true, mode: 'Dialog', allowEditing: true, allowDeleting: true };
    this.toolbar = ['Add', 'Edit', 'Delete']
    this.currentUser = this.authenticationService.currentUserValue;
    this.columns = [
      { field: 'Id', headerText: '', isPrimaryKey: true, visible: false },
      { field: 'User.FirstName', headerText: 'User' },
      { field: 'ReadOnly', headerText: 'ReadOnly', displayAsCheckBox: true, textAlign: 'Center'  },
    ]
    this.data = new DataManager({
      url: this.baseUrl + "SharedWith",
      adaptor: new ODataV4Adaptor(),
      headers: [{ 'Authorization': 'Bearer ' + this.currentUser.token }]
    });

    let predicate: Predicate = new Predicate('RelatedTypeId', 'equal', this.relatedTypeId)
      .and('RelatedId', 'equal', this.recordId);

    this.query = new Query().expand('User($select=Id,FirstName)')
      .where(predicate);

    this.userData = new DataManager({
      url: this.baseUrl + "User",
      adaptor: new ODataV4Adaptor(),
      headers: [{ 'Authorization': 'Bearer ' + this.currentUser.token }]
    });

    
    }
public onFiltering(e, obj: string) {
    e.preventDefaultAction = true;
    var predicate = new Predicate('FirstName', 'contains', e.text);
    var query = new Query();
    query = (e.text != "") ? query.where(predicate) : query;

    //pass the filter data source, filter query to updateData method.
    switch (obj) {
       case 'u':
        e.updateData(this.userData, query);
        break;
     }
  }

  actionBegin(args: SaveEventArgs): void {
    let objData: any = args.rowData;

    if (args.requestType === 'beginEdit' || args.requestType === 'add') {
      this.submitClicked = false;

      this.formData = this.formBuilder.group({
        Id: [objData.Id ? objData.Id : 0],
        RelatedTypeId : [this.relatedTypeId],
        RelatedId: [this.recordId],
        UserId: [objData.UserId, [Validators.required]],
        ReadOnly: [objData.ReadOnly ? objData.ReadOnly : false],
        
      });
    }
    if (args.requestType === 'save') {
      this.submitClicked = true;
      if (this.formData.valid) {
        args.data = this.formData.value;
      } else {
        args.cancel = true;
      }
    }
  }

  actionComplete(args): void {
    if(!this.isMobileView) {
    if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
      const dialog = args.dialog;
      dialog.showCloseIcon = false;
      dialog.element.style.maxHeight = '';
      dialog.height = '60vh';
      dialog.width = '60%';
      dialog.header = args.requestType === 'beginEdit' ? 'Edit Shared with' : 'Share with';      
      setTimeout(() => {
        const autoCompleteElem = args.form.querySelector('#UserId');
        const autoCompleteInstance = autoCompleteElem?.ej2_instances?.[0];
        if (autoCompleteInstance) {
          autoCompleteInstance.focusIn();
        }
      });
    }
  }
    if (args.requestType === 'save') {
      this.submitClicked = true;
      if (this.formData.valid) {
        args.data = this.formData.value;
      } else {
        args.cancel = true;
      }
    }
  }

  get f() {
    return this.formData.controls;
  }

}
